package com.sddamico.swigmore.models

import kotlinx.serialization.Serializable

/** A ranking method's rating and the team's rank by it; tied ratings share a rank. */
@Serializable
data class RatedRankDto(val rating: Double, val rank: Int)

/** The team's line in the blended coaches poll. */
@Serializable
data class CoachesVoteDto(val points: Int, val standing: PollStanding)

/**
 * One team in the computer polls. [composite] is the BCS-style blend, its rating a share between 0
 * and 1, and null while no coaches poll is blended in. [massey] rates in points of margin. [allPlay] and [pythagorean] rate win shares: the record
 * against every team every week ([allPlayRecord]), and the share expected from points for and
 * against. [strengthOfSchedule] rates the team's opponents by their average Colley rating.
 */
@Serializable
data class ComputerPollRowDto(
  val team: LeagueTeam,
  val owner: String?,
  val record: TeamRecord,
  val pointsFor: Double,
  val pointsAgainst: Double,
  val pointsPerGame: Double,
  /** The row's place in the table: its BCS rank, or its Colley rank while there is no composite. */
  val rank: Int,
  val composite: RatedRankDto?,
  val colley: RatedRankDto,
  val elo: RatedRankDto,
  val massey: RatedRankDto,
  val allPlayRecord: TeamRecord,
  val allPlay: RatedRankDto,
  val pythagorean: RatedRankDto,
  val strengthOfSchedule: RatedRankDto,
  /** Null when no published poll is blended in. */
  val coaches: CoachesVoteDto?,
)

/**
 * `GET /api/league/computer-poll`. [throughWeek] is the last week counted, null before any, and
 * [throughWeekFinal] is false while its scores can still change; [coachesPollWeek] is the published
 * poll blended in, null before the first.
 */
@Serializable
data class ComputerPollResponse(
  val throughWeek: Int?,
  val throughWeekFinal: Boolean,
  val coachesPollWeek: Int?,
  val rows: List<ComputerPollRowDto>,
)
